export default __webpack_public_path__ + "static/media/learose5-1024w.bfc5c5f1.webp";